import React, { FC, useState } from 'react'
import { useSelector } from 'react-redux'
import { SettingsStore } from '../../../store/settings/types'
import { Plann3rStore } from '../../../store/types'
import { Tiers } from '../../../types/plann3r'

const IntegrationsTab: FC<{
  showSubscriptionPopup: () => void,
}> = ({ showSubscriptionPopup }) => {
  const [selectedIntegration, setselectedIntegration] = useState(0)

  const { integrations, tier } = useSelector(
    (state: Plann3rStore): SettingsStore => state.settings,
  )

  const strings = useSelector(
    (state: Plann3rStore) => state.languages.strings.settings.settings,
  )

  const integration = integrations.find((integration) => {
    return integration.integration_id === selectedIntegration
  })

  return (
    <div className="part integrations">
      <h3 className="part_header">{strings.integrations}</h3>
      <div>
        <div className="columns">
          <div className="list column is-4">
            <ul>
              {integrations.map((integration) => {
                return (
                  <li
                    className={
                      selectedIntegration === integration.integration_id
                        ? 'selected cursor-pointer'
                        : 'cursor-pointer'
                    }
                    onClick={() => {
                      setselectedIntegration(integration.integration_id)
                    }}
                    key={integration.integration_id}
                    role="presentation"
                  >
                    <img src={integration.logo} alt={integration.name} />
                    <span>{integration.name}</span>
                  </li>
                )
              })}
            </ul>
          </div>
          {selectedIntegration > 0 && integration && !integration.connected && (
            <div className="actions column is-8">
              <div>
                <button
                  className="button is-primary"
                  onClick={() => {
                    if (tier?.toLowerCase() !== Tiers.FREE) {
                      window.location.href = decodeURI(integration.auth_url)
                    } else {
                      showSubscriptionPopup()
                    }
                  }}
                >
                  {strings.connect_to + ' ' + integration.name}
                </button>
              </div>
            </div>
          )}
          {selectedIntegration > 0 && integration && integration.connected && (
            <div className="actions column is-8">
              <h4>Connected</h4>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default IntegrationsTab
